<template>
  <div v-if="loading || visibleTags.length" class="content-tag-filter">
    <span class="filter-label">标签</span>
    <button
      v-for="tag in visibleTags"
      :key="tag.tagId"
      type="button"
      class="tag-chip"
      :class="{ active: Number(modelValue) === Number(tag.tagId) }"
      :style="chipStyle(tag)"
      @click="toggle(tag.tagId)"
    >
      {{ tag.name }}
    </button>
    <span v-if="showExpand || showCollapse || modelValue" class="tag-actions">
      <button
        v-if="showExpand"
        type="button"
        class="tag-icon"
        aria-label="全部标签"
        title="全部标签"
        @click="showAll = true"
      >
        <el-icon><ArrowDown /></el-icon>
      </button>
      <button
        v-else-if="showCollapse"
        type="button"
        class="tag-icon"
        aria-label="收起"
        title="收起"
        @click="showAll = false"
      >
        <el-icon><ArrowUp /></el-icon>
      </button>
      <button
        v-if="modelValue"
        type="button"
        class="tag-action tag-action--clear"
        @click="$emit('update:modelValue', 0)"
      >
        <el-icon><Close /></el-icon>
        清除
      </button>
    </span>
  </div>
</template>

<script>
import axios from 'axios'
import { ArrowDown, ArrowUp, Close } from '@element-plus/icons-vue'

export default {
  name: 'ContentTagFilterBar',
  components: { ArrowDown, ArrowUp, Close },
  props: {
    modelValue: { type: [Number, String], default: 0 },
    scope: { type: String, required: true }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      loading: false,
      recommended: [],
      allTags: [],
      showAll: false
    }
  },
  computed: {
    extraCount() {
      const recIds = new Set(this.recommended.map((t) => t.tagId))
      return this.allTags.filter((t) => !recIds.has(t.tagId)).length
    },
    visibleTags() {
      if (this.showAll || !this.recommended.length) {
        return this.allTags
      }
      return this.recommended
    },
    showExpand() {
      return !this.showAll && this.extraCount > 0
    },
    showCollapse() {
      return this.showAll && this.recommended.length > 0
    }
  },
  watch: {
    scope: {
      immediate: true,
      handler() {
        this.loadTags()
      }
    }
  },
  methods: {
    chipStyle(tag) {
      if (!tag?.color) return {}
      if (Number(this.modelValue) === Number(tag.tagId)) {
        return { background: tag.color, borderColor: tag.color, color: '#fff' }
      }
      return { borderColor: tag.color, color: tag.color }
    },
    toggle(tagId) {
      const next = Number(this.modelValue) === Number(tagId) ? 0 : Number(tagId)
      this.$emit('update:modelValue', next)
    },
    async loadTags() {
      if (!this.scope) return
      this.loading = true
      try {
        const [recRes, allRes] = await Promise.all([
          axios.post('/api/v1/content/tag/list', { scope: this.scope, recommendedOnly: 1 }),
          axios.post('/api/v1/content/tag/list', { scope: this.scope, recommendedOnly: 0 })
        ])
        this.recommended = recRes.data?.code === 200 ? (recRes.data.data?.tags || []) : []
        this.allTags = allRes.data?.code === 200 ? (allRes.data.data?.tags || []) : []
        if (!this.recommended.length) {
          this.showAll = true
        }
      } catch {
        this.recommended = []
        this.allTags = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.content-tag-filter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.filter-label {
  font-size: 13px;
  color: #606266;
  margin-right: 4px;
}

.tag-chip {
  border: 1px solid #dcdfe6;
  background: #fff;
  color: #606266;
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 13px;
  cursor: pointer;
  line-height: 1.4;
}

.tag-chip:hover {
  border-color: #409eff;
  color: #409eff;
}

.tag-chip.active {
  background: #409eff;
  border-color: #409eff;
  color: #fff;
}

.tag-actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 4px;
  padding-left: 10px;
  border-left: 1px solid #dcdfe6;
}

.tag-icon {
  -webkit-appearance: none;
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  color: #909399;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.tag-icon:hover {
  background: transparent;
  color: #409eff;
}

.tag-action {
  -webkit-appearance: none;
  appearance: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 28px;
  padding: 0 10px;
  border-radius: 4px;
  border: 1px solid #c0c4cc;
  background: #f4f4f5;
  color: #303133;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
}

.tag-action:hover {
  background: #e9e9eb;
  border-color: #909399;
  color: #303133;
}

.tag-action--clear {
  background: #fff;
  color: #f56c6c;
  border-color: #fbc4c4;
}

.tag-action--clear:hover {
  background: #fef0f0;
  color: #f56c6c;
  border-color: #f56c6c;
}
</style>
